module.exports = __webpack_public_path__ + "static/dashboard-ed022fb514e8f4634c990df7cf00728f.png";